<template>
  <div class="view" v-if="canEdit || canDelete" v-cloak>
    <card :title="title" id="employee-role-list">
      <agro-filter-container :new-object="newObject" :title='$t("common.create_new")'>
        <s-c-employee-role-filters ref="filters" @onFiltersApplied="onFiltersApplied"/>
      </agro-filter-container>
    </card>
    <div class="content-body pt-4">
      <div class="row">
        <div class="col-lg-12">
          <agro-grid
            :headers="headers"
            :rows="items"
            :paginate="true"
            :permission="config"
            :action="onPageSelected"
            :loading="loading"
          >
          </agro-grid>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as type from '../../../store/mutation-types'
import SCEmployeeRoleFilters from "@/pages/salary-calculator/sc-employee-role/partials/SCEmployeeRoleFilters";
import AgroGrid from "@/components/AgroGrid/index";
import {canDelete, canEdit, permissions, permissionTypes} from "@/helpers/Permissions";
import Forbidden from "~/pages/errors/Forbidden.vue";
import AgroFilterContainer from "@/components/AgroFilter/partials/AgroFilterContainer.vue";

export default {
  name: 'SCEmployeeRoleList',
  middleware: ['auth', 'check-company-admin'],
  data() {
    return {
      currentPage: 1,
      filters: this.scEmployeeRoleFilters ? this.scEmployeeRoleFilters : {},
      items: this.scEmployeeRoles ? this.scEmployeeRoles : [],
      pager: this.pagination ? this.pagination : {},
      loading: false,
    }
  },
  components: {
    AgroFilterContainer,
    Forbidden,
    AgroGrid,
    SCEmployeeRoleFilters,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      scEmployeeRoleFilters: 'scEmployeeRole/scEmployeeRoleFilters',
      scEmployeeRoles: 'scEmployeeRole/scEmployeeRoles',
      pagination: 'common/pagination',
      users: 'user/users',
    }),
    title() {
      return this.$t('salary_calculator.employee_role.title');
    },
    config() {
      return {
        permission: permissions.SC_EMPLOYEE_ROLE,
        permission_type: permissionTypes.module,
        edit: {
          url: '/salary-calculator/sc-employee-role/{uuid}',
          callback: this.onItemEdited,
        },
        delete: {
          method: this.deleteObject,
          callback: this.onItemDeleted,
        }
      };
    },
    canEdit() {
      return canEdit(this);
    },
    canDelete() {
      return canDelete(this);
    },
    headers() {
      return  [
        { name: this.$t('common.name'), col: 'name', width: '25%' },
        { name: this.$t('common.shift'), col: 'shift.full_link', width: '30%' },
        { name: this.$t('common.created_at'), col: 'created_at', width: '20%' },
        { name: this.$t('common.last_update'), col: 'updated_at', width: '20%' },
      ];
    },
  },
  methods: {
    ...mapActions({
        deleteObject: 'scEmployeeRole/deleteSCEmployeeRole',
    }),
    onPageSelected(page_id) {
      this.filters.page = page_id;
      this.$store.commit("scEmployeeRole/"+type.SET_SC_EMPLOYEE_ROLE_FILTERS, this.filters);
      this.$refs.filters.applyFilters();
    },
    newObject() {
      this.$router.push({
        path: 'sc-employee-role/add'
      });
    },
    onItemEdited(item) {
      console.log('onItemEdited', item);
    },
    onItemDeleted(item) {
      console.log('onItemDeleted', item);
    },
    onFiltersApplied(filters) {
      this.loading = true;
    }
  },
  watch: {
    scEmployeeRoles: {
      handler: function(newVal) {
        this.items = newVal;
      },
      deep: true,
    },
    pagination: {
      handler: function(newVal) {
        this.pager = newVal;
      },
      deep: true,
    },
  }
}
</script>

<style scoped>

</style>
